var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"headline"},[_vm._v("Editar perfil")])])],1),_c('PersonaUpdate',{attrs:{"persona":_vm.cliente.persona}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }